import buildUrl from "../helpers/buildUrl";
import buildUrlLocation from "../helpers/buildUrlLocation";
import fetchClient from "../helpers/fetchClient";
import isEmpty from "../helpers/isEmpty";
import CaseStudyModel from "../models/CaseStudyModel";
import PagedResponse from "../models/PagedResponse";

/**
 * Fetch case studies from api
 *
 * @param {string} protocol - protocol of the request, i.e. http:// or https://
 * @param {string} host - host of the request, i.e. loomis.en-gb.dev.docker
 * @param {string} apiSuffix -  api suffix, i.e. /api/loomis/news
 * @param {string} folderId - folder id, i.e. {FF005073-5F75-488C-8242-3E83FFC239AA}
 * @param {number} page - page to fetch
 * @param {number} perPage - how many per page
 * @param {string} solutionId - solution id
 * @param {string} sectorialSolutionId - sectorial solution id
 * @return {Object} json response
 */
const caseStudiesFetch = async (
  protocol,
  host,
  apiSuffix,
  folderId,
  page,
  perPage,
  solutionId,
  sectorialSolutionId
) => {
  let url = "";
  if (protocol && host && apiSuffix) {
    url = buildUrl(protocol, host, apiSuffix, [folderId], {
      page,
      perPage,
      solutionId,
      sectorialSolutionId,
    });
  } else {
    url = buildUrlLocation(
      [apiSuffix, folderId],
      {
        page,
        perPage,
        solutionId,
        sectorialSolutionId,
      },
      true
    );
  }

  const response = await fetchClient(url);
  if (response.success && response.data) {
    const pagedResponse = new PagedResponse(response.data);
    const caseStudies = [];
    if (
      !isEmpty(response.data.caseStudies) &&
      Array.isArray(response.data.caseStudies)
    ) {
      response.data.caseStudies.forEach((caseStudy) =>
        caseStudies.push(new CaseStudyModel(caseStudy))
      );
      pagedResponse.setResults(caseStudies);
    }
    response.data = pagedResponse;
  }
  return response;
};

export default caseStudiesFetch;
